// Vendor imports
const { createSelector } = require('reselect')

const containerState = state => state.lightweightEngagementTutorial

const isVisible = createSelector(
  containerState,
  s => s ? s.isVisible : false
)

const slides = createSelector(
  containerState,
  s => s ? s.slides : undefined
)

const slideCount = createSelector(
  slides,
  slides => slides ? slides.size : 0
)

// Exports

module.exports = {
  isVisible,
  slides,
  slideCount
}
